import { render, staticRenderFns } from "./statsmainTab.vue?vue&type=template&id=760d1e1b&"
import script from "./statsmainTab.vue?vue&type=script&lang=js&"
export * from "./statsmainTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports